import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const userAssignmentService = {
  getActivityAssignments: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/user/assignments-by-activity/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  saveUserActivityAssignments: async (user, userAssignmentData) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user/save-user-activity-assignment`,
        userAssignmentData,
        getAxiosOptions(user)
      )
    ).data
  },
  updateUserActivityAssignments: async (user, userAssignmentData) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user/update-user-activity-assignment`,
        userAssignmentData,
        getAxiosOptions(user)
      )
    ).data
  },
  saveUserActivityAssignmentAndRemoveDuplicates: async (user, userAssignmentData) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/user/save-user-activity-assignment-and-remove-duplicates`,
        userAssignmentData,
        getAxiosOptions(user)
      )
    ).data
  },
}
